module.exports = __webpack_public_path__ + "vrgroup.278f2187c84bcd56ff22.worker.js"